import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { assets } from '../../../core/constants/assets.const';

@Component({
  selector: 'rental-no-data-found',
  standalone: true,
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  imports: [TranslateModule]
})
export class NoDataFoundComponent {
  assetConst = assets;
}
